import Img from './backspace.png';
import './Backspace.css';

const Backspace = () => {
    return (
        <img className='img-backspace' src={Img} alt="" />
    );
}

export default Backspace;
